import { Injectable, inject } from '@angular/core';
import { type HttpErrorResponse } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, switchMap, catchError } from 'rxjs/operators';

import { UserHttpService } from '@web/store/user/user.http.service';

import AppActions from '@web/store/app/app.actions';
import * as UserActions from './user.actions';
import { setEduUserContext, setUserContext } from '@common/configs/sentry.browser.config';

@Injectable()
export class UserEffects {
    private readonly actions$ = inject(Actions);
    private readonly userHttpService = inject(UserHttpService);

    public readonly loadUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.initAppRequest),
            filter(({ site }) => !!site),
            switchMap(() =>
                this.userHttpService.getUser().pipe(
                    map((user) => {
                        setUserContext(user);

                        return UserActions.loadUserSuccess({ user });
                    }),
                    catchError(({ message }: HttpErrorResponse) => [UserActions.loadUserFailure({ error: message })])
                )
            )
        )
    );

    public readonly loadEduUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.initAppRequest),
            filter(({ site }) => !!site),
            switchMap(() =>
                this.userHttpService.getEduUser().pipe(
                    map((eduUser) => {
                        setEduUserContext(eduUser);

                        return UserActions.loadEduUserSuccess({ eduUser });
                    }),
                    catchError(({ message }: HttpErrorResponse) => [
                        UserActions.loadEduUserFailure({ eduUserError: message }),
                    ])
                )
            )
        )
    );

    public readonly loadMemberAreaUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.initAppRequest),
            filter(({ site }) => !!site),
            switchMap(() =>
                this.userHttpService.getMemberAreaUser().pipe(
                    map((memberAreaUser) => UserActions.loadMemberAreaUserSuccess({ memberAreaUser })),
                    catchError(({ message }: HttpErrorResponse) => [
                        UserActions.loadMemberAreaUserFailure({ memberAreaUserError: message }),
                    ])
                )
            )
        )
    );
}
